// src/pages/beta-community/components/Footer.jsx
import React from 'react';
import { ROOT_HOST, ROOT_URL, VISION_HOST } from '../../../config/domains';

const Footer = () => {
  return (
    <footer className="beta-footer">
      <div className="container">
        <p><strong>Artkiv</strong> — Gestion, valorisation et transmission des collections</p>
        <p className="footer-links">
          <a href="mailto:support@artkiv.com">support@artkiv.com</a>
          {' · '}
          <a href={ROOT_URL} target="_blank" rel="noopener noreferrer">{ROOT_HOST}</a>
          {' · '}
          <a href={`https://${VISION_HOST}`} target="_blank" rel="noopener noreferrer">{VISION_HOST}</a>
        </p>
        <p className="footer-copyright">© 2026 Artkiv. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;